/** Phase4-R Lite：项目进展已并入日报填写 */
export const PROJECT_REPORT_MERGE_NOTICE =
  '项目进展已合并到日报，请在日报中填写。';

/** T6：删除日报确认框补充说明 */
export const DELETE_DAILY_REPORT_FUSION_HINT =
  '删除日报后，本次日报关联的项目进展也将同步删除。';

export const DELETE_DAILY_REPORT_FUSION_SUCCESS = '日报及关联项目进展已删除';

export const DELETE_DAILY_REPORT_AFTER_PR_SUCCESS_FAILURE =
  '项目进展已删除，日报删除失败，请重试。';

/** T6.1-B：无 Lite Store 时 fallback 删除成功提示 */
export const DELETE_FUSION_FALLBACK_APPLIED_WARNING =
  '未找到本地 Lite Store，已按日报日期与提交时间推断并删除关联融合项目进展。';

export const DELETE_FUSION_FALLBACK_WITH_HISTORICAL_WARNING =
  '未找到本地 Lite Store，已删除日报提交后的融合项目进展；同日更早的独立项目日报已保留。';

export const DELETE_FUSION_FALLBACK_UNRELIABLE_WARNING =
  '无法可靠识别融合项目进展，已跳过关联删除，仅删除日报。历史独立项目日报不受影响。';
